<template>
  <v-dialog
    v-model="isVisible"
    persistent
    max-width="512"
  >
    <v-card style="min-height: 500px;">
      <v-card-title class="headline">{{ $i18n.t(`dashboard.projects.attributesSettings`) }}</v-card-title>
      <v-progress-linear
        indeterminate
        color="primary"
        v-if="isLoader"
      />
      <template v-if="isDataReady">
        <v-row
          class="justify-end"
          no-gutters
        >
          <v-col
            sm="10"
            cols="12"
          >
            <v-row
              no-gutters
              class="justify-end pr-6"
            >
              <v-btn
                text
                color="primary"
                @click="setAll(false)"
                class="pa-2"
                :title="$i18n.t('dialog.confirmation.unselectAll')"
              >{{ $i18n.t('dialog.confirmation.unselectAll') }}</v-btn>
              <v-btn
                class="pa-2 primary--text"
                text
                :title="$i18n.t('dialog.confirmation.selectAll')"
                @click="setAll(true)"
              >{{ $i18n.t('dialog.confirmation.selectAll') }}</v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text
          style="height: 50vh"
          class="pa-0"
          v-bar
        >
          <v-row no-gutters>
            <v-col
              cols="12"
              xs="12"
            >
              <v-expansion-panels accordion>
                <draggable
                  v-model="attributes"
                  @change="onReorder"
                  handle=".handle"
                  style="width: 100%"
                >
                  <v-expansion-panel
                    v-for="attribute in attributes"
                    :key="attribute.name"
                  >
                    <v-expansion-panel-header>
                      <v-row style="line-height:24px">
                        <v-icon
                          color="primary"
                          class="handle pr-4"
                          :title="$i18n.t(`default.drag`)"
                        >mdi-drag</v-icon>
                        {{ $i18n.t(`offer.categories.${attribute.name}`) }}
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row class="justify-end">
                        <v-col
                          cols="12"
                          sm="3"
                          class="pa-0"
                        />
                      </v-row>

                      <v-list>
                        <v-list-item class="list__item--all">
                          <v-list-item-content>{{ $i18n.t('offer.attachments.table.name') }}</v-list-item-content>
                          <v-list-item-action>
                            <v-checkbox
                              v-model="switchValues[attribute.name]"
                              hide-details
                              dense
                              indeterminate
                              color="primary"
                              @change="setGroup(attribute.name)"
                            />
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                        <v-list-item
                          v-for="attr in attribute.attributes"
                          :key="attr.name"
                        >
                          <v-list-item-content>{{ attr[`name_${$i18n.locale}`] || 'No translation' }}</v-list-item-content>
                          <v-list-item-action>
                            <v-checkbox
                              dense
                              color="primary"
                              v-model="attr.visible"
                            />
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </draggable>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="primary"
            text
            @click="close"
          >{{ $i18n.t('dialog.confirmation.close') }}</v-btn>
          <v-btn
            color="primary"
            text
            :title="$i18n.t('dialog.confirmation.save')"
            @click="save"
          >{{ $i18n.t('dialog.confirmation.save') }}</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  components: {
    draggable
  },
  props: {
    isVisible: {
      required: true,
      type: Boolean
    },
    projectId: {
      required: true,
      type: [Number, String]
    }
  },
  data: () => ({
    attributes: [],
    attributesGroups: [],
    isLoader: true,
    isDataReady: false,
    switchValues: {}
  }),
  methods: {
    close() {
      this.$emit('closeAtrributes');
    },
    async save() {
      try {
        const response = await this.$store.dispatch('saveAttributesConfig', {
          id: this.projectId,
          body: { data: this.attributes }
        });
        if (response.status === 204) {
          this.close();
        }
      } catch (error) {
        this.$root.$emit('showSnackbar', error);
      }
    },
    setAll(value) {
      this.attributes.forEach(group => {
        group.attributes.forEach(attribute => {
          this.switchValues[group.name] = value;
          attribute.visible = value;
        });
      });
    },
    setGroup(group) {
      const attributesGroup = this.attributes.find(g => g.name === group);
      attributesGroup.attributes.forEach(attr => {
        attr.visible = this.switchValues[group];
      });
    },
    onReorder({ moved }) {
      this.attributes = this.attributes.map((attr, index) => {
        attr.order = index;
        return attr;
      });
    },
    async getAttributesConfig() {
      try {
        const response = await this.$store.dispatch(
          'getAttributesConfig',
          this.projectId
        );
        this.attributes = response.data.data;
        response.data.data.forEach(group => {
          this.switchValues[group] = false;
        });
        setTimeout(() => {
          this.isLoader = false;
          this.isDataReady = true;
        }, 1000);
      } catch (error) {
        this.$root.$emit('showSnackbar', error);
      }
    }
  },
  mounted() {
    this.getAttributesConfig();
  }
};
</script>

<style lang="scss">
</style>
